import { computed, observable } from 'mobx';

import config from '../../config';

class TicketBaseViewStore {
  @observable accessor purchaseDataStore;
  get config() {
    return config;
  }

  get staticUrl() {
    return config['static_url'];
  }

  get facility() {
    return config.facility;
  }

  @computed get prefersPhone() {
    const { preferred_contact_method } = this.facility;
    return (
      preferred_contact_method === 'phone' || preferred_contact_method === 'all'
    );
  }

  @computed get prefersEmail() {
    const { preferred_contact_method } = this.facility;
    return (
      preferred_contact_method === 'email' || preferred_contact_method === 'all'
    );
  }

  @computed get showMiddleSection() {
    return (
      this.activeObject.image ||
      (this.facility.location && this.facility.google_map_key)
    );
  }

  @computed get activeObject() {
    return config.object;
  }
  @computed get activePurchaseObject() {
    return this.purchaseDataStore.activeObject;
  }
  @computed get lastPurchase() {
    const objs = this.purchaseDataStore.objects.slice();
    return objs[objs.length - 1];
  }
}

export default TicketBaseViewStore;
